;(function (e) {
  e.fn.hovercard = function (b) {
    b = e.extend(
      {
        openOnLeft: !1,
        openOnTop: !1,
        cardImgSrc: "",
        detailsHTML: "",
        showCustomCard: !1,
        customCardJSON: {},
        customDataUrl: "",
        delay: 0,
        autoAdjust: !0,
        onHoverIn: function () {},
        onHoverOut: function () {},
      },
      b
    )
    return this.each(function () {
      function h(d) {
        let a = d.find(".hc-details").eq(0),
          c = d[0].getBoundingClientRect()
        d = c.left + 335 + a.width()
        c = c.top + 335 + a.height()
        b.openOnLeft || (b.autoAdjust && d > window.innerWidth)
          ? a.addClass("hc-details-open-left")
          : a.removeClass("hc-details-open-left")
        b.openOnTop || (b.autoAdjust && c > window.innerHeight)
          ? a.addClass("hc-details-open-top")
          : a.removeClass("hc-details-open-top")
      }
      let c = e(this)
      c.wrap('<div class="hc-preview" />')
      c.addClass("hc-name")
      let f = ""
      0 < b.cardImgSrc.length && (f = '<img class="hc-pic" src="' + b.cardImgSrc + '" />')
      c.after('<div class="hc-details" >' + f + b.detailsHTML + "</div>")
      c.siblings(".hc-details").eq(0).css({ width: b.width, background: b.background })
      c.closest(".hc-preview").hover(
        function () {
          var d = e(this)
          h(d)
          d.css("zIndex", "200")
          c.css("zIndex", "100").find(".hc-details").css("zIndex", "50")
          let a = d.find(".hc-details").eq(0)
          a.stop(!0, !0).delay(b.delay).fadeIn()
          if ("function" == typeof b.onHoverIn) {
            if (b.showCustomCard && 0 >= a.find(".s-card").length) {
              let f = b.customDataUrl
              "undefined" != typeof c.attr("data-hovercard") &&
                0 < c.attr("data-hovercard").length &&
                (f = c.attr("data-hovercard"))
              var d = b.customCardJSON,
                g,
                j
              g = function (a) {
                return (
                  '<div class="s-card s-card-pad">' +
                  (a.image ? '<img class="s-img" src=' + a.image + " />" : "") +
                  (a.name ? '<label class="s-name">' + a.name + " </label><br/>" : "") +
                  (a.link ? '<a class="s-loc" href="' + a.link + '">' + a.link + "</a><br/>" : "") +
                  (a.bio ? '<p class="s-desc">' + a.bio + "</p>" : "") +
                  (a.website
                    ? '<p class="s-desc"><span class="s-strong">Web:</span><br/><a href="' +
                      a.website +
                      '">' +
                      a.website +
                      "</a></p>"
                    : "") +
                  (a.email
                    ? '<p class="s-desc"><span class="s-strong">Email:</span><br/><a href="' +
                      a.email +
                      '">' +
                      a.email +
                      "</a></p>"
                    : "") +
                  "</div>"
                )
              }
              j = function () {}
              e.isEmptyObject(d) && !a.hasClass("busy-loading")
                ? (a.addClass("busy-loading"),
                  e.ajax({
                    url: f,
                    type: "GET",
                    dataType: "jsonp",
                    timeout: 4e3,
                    beforeSend: function () {
                      a.find(".s-message").remove()
                      a.append('<p class="s-message">Loading...</p>')
                    },
                    success: function (c) {
                      0 >= c.length
                        ? a.find(".s-message").html("Sorry, no data found.")
                        : (a.find(".s-message").remove(),
                          a.prepend(g(c)),
                          h(a.closest(".hc-preview")),
                          a.stop(!0, !0).delay(b.delay).fadeIn(),
                          j(c))
                      a.removeClass("busy-loading")
                    },
                    error: function () {
                      a.find(".s-message").html("Sorry, no data found.")
                      a.removeClass("busy-loading")
                    },
                  }))
                : a.prepend(g(d))
            }
            b.onHoverIn.call(this)
          }
        },
        function () {
          const $this = e(this)
          $this
            .find(".hc-details")
            .eq(0)
            .stop(!0, !0)
            .fadeOut(300, function () {
              $this.css("zIndex", "0")
              c.css("zIndex", "0").find(".hc-details").css("zIndex", "0")
              "function" == typeof b.onHoverOut && b.onHoverOut.call(this)
            })
        }
      )
    })
  }
})(jQuery)
